
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const gridlock: Operator = {
	id: 'gridlock',
	name: 'Gridlock',
	role: 'Attacker',
	org: 'SASR',
	squad: 'REDHAMMER',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 1
	},
	meta: {
		gender: 'f',
		country: 'au',
		season: 'Y4S1',
		height: 177,
		weight: 102,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Tori Tallyo Fairous',
		birthplace: 'Longreach, Australia'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z"></path><circle cx="175" cy="175" r="122.5"></circle><path d="m258.257 152.45-21.278-36.855 18.349-11.272C235.719 82.054 207.003 68 175 68c-59.094 0-107 47.906-107 107 0 11.456 1.807 22.487 5.14 32.835l19.447-10.192 21.278 36.855-18.851 11.566C114.614 268.107 143.183 282 175 282c59.094 0 107-47.906 107-107 0-11.266-1.746-22.124-4.974-32.323z" style="fill:#d31850"></path><path d="M226.889 172.111V65.555A129.6 129.6 0 0 0 175 54.666a129.6 129.6 0 0 0-52 10.889v106.556l28.868-7.406v44.739c.008 1.736-.294 3.258-.897 4.568-1.421 3.084-4.649 5.077-8.387 7.385a39.6 39.6 0 0 1-5.339 2.76l-5.489 2.326v62.239h19.377c4.418 3.806 12.612 9.1 24.003 9.111 11.439 0 19.652-5.301 24.076-9.111h19.266v-61.416l-4.569-2.584a998 998 0 0 1-8.467-4.844c-2.84-1.643-3.402-1.993-3.647-2.212-.312-.278-1.914-1.792-2.827-4.348a11.4 11.4 0 0 1-.657-3.62v-44.935zM175 268.333c-8.008 0-14.5-6.492-14.5-14.5s6.492-14.5 14.5-14.5 14.5 6.492 14.5 14.5-6.492 14.5-14.5 14.5"></path><path d="M175 230.611c11.941 0 21.794 8.813 23.295 20.222h11.184v-18.278a1024 1024 0 0 1-8.542-4.887c-3.57-2.066-4.207-2.463-5.124-3.28-.675-.6-3.633-3.325-5.318-8.041a20.4 20.4 0 0 1-1.182-6.57V154.11l-6.59-1.576v58.132a7 7 0 0 1-7 7h-1.208a7 7 0 0 1-7-7v-58.133l-6.646 1.577v55.333c.019 3.93-.981 6.724-1.722 8.333-2.557 5.55-7.329 8.497-11.833 11.278a48.5 48.5 0 0 1-6.556 3.389v18.389h10.948c1.5-11.408 11.353-20.221 23.294-20.221m0 46.5c-11.253 0-20.653-7.827-22.956-18.278h-11.287v20.889h14c1.117 1.244 8.411 9.099 20.389 9.111 12.01.012 19.331-7.87 20.444-9.111h13.889v-20.889h-11.523c-2.303 10.451-11.703 18.278-22.956 18.278" style="fill:#fff"></path><path d="M217.833 103.624a158.66 158.66 0 0 0-85.556 0v56.46c1.047-.348 3.238-1.076 6.111-2.028 3.559-1.179 4.139-1.368 5.111-1.833 2.638-1.262 2.653-1.932 5.889-3.972 2.936-1.851 5.464-2.901 7.09-3.568 3.13-1.284 5.61-1.936 6.133-2.071 5.498-1.423 9.958-1.394 12.444-1.361 5.392.072 9.488.962 11.056 1.333 1.425.338 6.617 1.597 10.972 4.028.726.405 2.54 1.463 4.5 2.667 1.579.97 2.682 1.683 2.917 1.833 1.794 1.144 5.383 2.799 13.333 4.957zm-42.75 29.682c-6.351 0-11.5-5.149-11.5-11.5s5.149-11.5 11.5-11.5 11.5 5.149 11.5 11.5-5.149 11.5-11.5 11.5m-42.805-41.028A170.8 170.8 0 0 1 175 86.831a170.7 170.7 0 0 1 42.833 5.447l-.056-22.213c-2.59-.89-6.315-2.061-10.873-3.117-11.628-2.695-20.53-2.754-31.905-2.76-10.801-.005-19.194.039-30.278 2.424a112 112 0 0 0-12.5 3.454q.03 11.105.057 22.212" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-gridlock'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
